import {
  getRoomById,
  wallsOfRoom,
  whichRoomIsPointInFromRooms
} from "src/components/Planner/planner/uDev";
import {
  setMode,
  toolbarSwitchSet
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import $ from "jquery";
import {radToDeg, uMath} from "src/components/Planner/planner/uMath";
import {ts} from "src/utils/translate"
import {
  getAuthHeaderSync,
  setProgressBarStatus,
  startLoading,
  stopLoading,
  toastInfoSingle
} from "src/components/Planner/controller";
import {ROOT_URI} from "src/utils/constants"
import * as d3 from "d3";

export class LightingCalcTransfer {
  constructor(gatheredRooms, gatheredLengthOf1Px, gatheredFloorIdToRooms) {
    this.setInitialVars();
    this.fpsLimit = -1;
    this.lowRes = 300;
    this.highRes = 900;
    this.abortController = null;
    this.prevObjectUrl = null;
    this.colors = [
      [0, 0, 128], // dark blue
      [0, 255, 0], // green
      [255, 255, 0], // yellow
      [255, 128, 0], // orange
      [255, 0, 0], // red
    ];
    this.domain = [
      0, // 1
      .25, // 10
      .5, // 100
      .75, // 1000
      1 // 10000
    ];
    this.colorsNew = [
      [0,0,0],
      [28,0,38],
      [0,0,61],
      [61,0,63],
      [103,0,58],
      [125,0,133],
      [153,46,158],
      [135,61,254],
      [111,96,254],
      [0,66,254],
      [52,143,254],
      [114,169,254],
      [8,227,227],
      [12,219,202],
      [9,220,145],
      [43,231,0],
      [158,222,82],
      [184,227,90],
      [222,254,82],
      [254,254,0],
      [254,225,138],
      [254,179,28],
      [254,137,0],
      [254,0,0],
      [254,86,68],
      [254,148,153],
      [226,226,226],
    ];
    this.domainNew = [
      0.10,
      0.4,
      1.58,
      6.3,
      25.10,
      100.00,
      114,
      131,
      150,
      171,
      196,
      225,
      258,
      295,
      338,
      387,
      443,
      507,
      581,
      665,
      762,
      872,
      999,
      1144,
      1310,
      1500,
      15000
    ];
    this.gatheredRooms = gatheredRooms || {};
    this.gatheredLengthOf1Px = gatheredLengthOf1Px;
    this.gatheredFloorIdToRooms = gatheredFloorIdToRooms;
  }

  /**
   *
   * @param {number} roomId
   * @returns {Room}
   */
  getRoomById(roomId) {
    if (typeof this.gatheredRooms === "object" && roomId in this.gatheredRooms) {
      return this.gatheredRooms[roomId];
    }
    else {
      return getRoomById(roomId);
    }
  }

  /**
   *
   * @param {number} floorId
   * @returns {number}
   */
  getLengthOf1Px(floorId) {
    if (typeof this.gatheredLengthOf1Px === "object" && floorId in this.gatheredLengthOf1Px) {
      return this.gatheredLengthOf1Px[floorId];
    }
    else {
      return PlannerGlobals.LENGTHOF1PX;
    }
  }

  /**
   *
   * @param {number} floorId
   * @returns {Room[]}
   */
  getFloorRooms(floorId){
    if (typeof this.gatheredFloorIdToRooms === "object" && floorId in this.gatheredFloorIdToRooms) {
      return this.gatheredFloorIdToRooms[floorId];
    }
    else {
      return PlannerGlobals.rooms;
    }
  }

  lerp(start, end, t) {
    return start;
    //return (1 - t) * start + t * end;
  }

  /**
   *
   * @param {number} t Value from 0 to 1
   * @returns {[number,number,number,number]} RGBA array
   */
  getColorFor(t) {
    if (t < 0) { t = 0; }
    else if (t > 1) { t = 1; }

    if (t <= this.domain[0]) {
      const first = this.colors[0];
      const alpha = t / this.domain[0];
      return [first[0], first[1], first[2], alpha];
    }

    if (t >= this.domain[this.domain.length - 1]) {
      const last = this.colors[this.colors.length - 1];
      return [last[0], last[1], last[2], 1];
    }

    for (var i = 0; t > this.domain[i]; i++);

    var from = this.colors[i - 1];
    var to = this.colors[i];
    t = (t - this.domain[i - 1]) / (this.domain[i] - this.domain[i - 1]);
    return [
      this.lerp(from[0], to[0], t),
      this.lerp(from[1], to[1], t),
      this.lerp(from[2], to[2], t),
      1
    ];
  }

  getColorForLux(lux) {
    /* if (lux < 0) { lux = 0; }
    else if (lux > 1) { lux = 1; } */

    if (lux <= this.domainNew[0]) {
      const first = this.colorsNew[0];
      return [first[0], first[1], first[2], 1];
    }

    if (lux >= this.domainNew[this.domainNew.length - 1]) {
      const last = this.colorsNew[this.colorsNew.length - 1];
      return [last[0], last[1], last[2], 1];
    }

    for (var i = 0; lux > this.domainNew[i]; i++);

    var from = this.colorsNew[i - 1];
    var to = this.colorsNew[i];
    lux = (lux - this.domainNew[i - 1]) / (this.domainNew[i] - this.domainNew[i - 1]);
    return [
      this.lerp(from[0], to[0], lux),
      this.lerp(from[1], to[1], lux),
      this.lerp(from[2], to[2], lux),
      1
    ];
  }

  setInitialVars() {
    this.currentAjax = null;
    this.currentRequestedFrame = null;
    this.willDraw = false;
    this.willRequestForFloor = null;
    this.willRequestTimeout = null;
    this.lastDrawTime = null;
    this.inLightCalcMode = false;
    this.lightCalcLoading = false;
    this.debug = [];
  }

  setFPSLimit(fps) {
    this.fpsLimit = fps;
  }

  unsetFPSLimit() {
    this.fpsLimit = -1;
  }

  setLowRes(res) {
    this.lowRes = res;
  }

  setHighRes(res) {
    this.highRes = res;
  }

  FPSLimitsDraw() {
    if (this.fpsLimit === -1 || !this.lastDrawTime) { return false; }
    const frameTime = 1000 / this.fpsLimit;
    const currTime = performance.now();
    return this.lastDrawTime + frameTime > currTime;
  }

  requestLighting(floorId) {
    this.willRequestForFloor = floorId;
    if (this.currentAjax || this.willDraw || this.FPSLimitsDraw()) {
      return;
    }
    this.startAjax(floorId);
  }

  debugBandwidth(respTime, sizeMB) {
    const currTime = performance.now();
    const tenSecBefore = currTime - 10 * 1000;

    this.debug = this.debug.filter(elem => elem.time > tenSecBefore);

    this.debug.push({ respTime, sizeMB, time: performance.now() });

    const elapsedSec = (this.debug[this.debug.length - 1].time - this.debug[0].time) / 1000;
    const avgResp = this.debug.reduce((p, c) => p + c.respTime, 0) / this.debug.length;
    const MBps = this.debug.reduce((p, c) => p + c.sizeMB, 0) / elapsedSec;

    const FPS = this.debug.filter(elem => elem.time > currTime - 2000).length / 2;

    toastInfoSingle(`<div><div>Average draw time: ${avgResp.toFixed(2)} ms</div><div>Bandwidth: ${MBps.toFixed(2)}MB/s (${(MBps * 8).toFixed(2)} Mb/s)</div><div>FPS: ${FPS}</div></div>`)
  }

  drawText(ctx, point, angle, scale = 1, text, color = "black") {
    ctx.save();
    ctx.fillStyle = color;
    ctx.font = `bold ${11 * scale}px Courier`;
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.translate(point.x * scale, point.y * scale);
    ctx.rotate(angle);
    ctx.fillText(text, 0, 0);
    ctx.restore();
  }

  drawLine(ctx, fromX, fromY, toX, toY, scale) {
    ctx.moveTo(fromX * scale, fromY * scale);
    ctx.lineTo(toX * scale, toY * scale);
  }

  startAjax(floorId) {
    return new Promise((res, rej) => {
      startLoading();
      setProgressBarStatus(ts("p_lightcalc_loading", "Lighting preview is loading..."));
      $('.progress').hide();

      this.stopBackgroundTasks();

      this.currentAjax = $.ajax({
        headers: getAuthHeaderSync(),
        url: ROOT_URI + "/lighting/calculation",
        method: "POST",
        data: { floor_id: floorId },
        dataType: 'JSON',
        success: (result) => {
          try {
            if (!result.rooms.length || result.rooms.every(room => room.output_values.length === 0)) {
              return rej(new Error(ts("p_lightcalc_no_data", "No lighting data to display. Place a compatible lamp on the floor.")));
            }

            this.revokeLastUrl();
            const st = +new Date();
            const url = this.serverResultToDataURL(result, floorId);
            const et = +new Date();
            console.log('draw+paint', et - st + "ms")
            this.prevObjectUrl = url;

            var existing = d3.select('#lightingCalc');
            if (existing.empty()) {
              PlannerGlobals.container
              .insert("svg:image", ".devices")
              .style('pointer-events', 'none')
              .style('opacity', '0.8')
              .attr('width', 900)
              .attr('height', 900)
              .attr("x", 0)
              .attr("y", 0)
              .attr("xlink:href", url)
              .attr("id", "lightingCalc");
            }
            else {
              existing.attr("xlink:href", url);
            }

            stopLoading();
            this.currentAjax = null;
            return res();
          }
          catch (err) {
            console.error(err);
            return rej(new Error(ts("p_lightcalc_failed", "Lighting calculation failed.")));
          }
        },
        error: (err) => {
          this.stopCalculation();
          stopLoading();
          this.currentAjax = null;
          return rej(new Error(ts("p_lightcalc_failed", "Lighting calculation failed.")));
        }
      });
    });
  }

  fetchBlob(floorId, resolution) {
    var url = new URL("http://localhost:3000/lightingcalc-server-2");
    floorId !== undefined && url.searchParams.append('floorId', floorId);
    resolution !== undefined && url.searchParams.append('res', resolution);

    return fetch(url.href)
    .then(res => { return res.blob() })
    .then(blob => {
      return URL.createObjectURL(blob);
    });
  }

  fetchBase64(floorId, resolution) {
    var url = new URL("http://localhost:3000/lightingcalc-server-2");
    floorId !== undefined && url.searchParams.append('floorId', floorId);
    resolution !== undefined && url.searchParams.append('res', resolution);

    return fetch(url.href)
    .then(res => { return res.blob() })
    .then(blob => {
      return new Promise((res, rej) => {
        var reader = new FileReader();
        reader.onload = function () {
          var dataUrl = reader.result;
          return res(dataUrl);
        };
        reader.onerror = function () {
          return rej();
        }
        reader.readAsDataURL(blob);
      })
    });
  }

  serverResultToDataURL(result, floorId) {
    const lengthOf1Px = this.getLengthOf1Px(floorId);
    const allRoomsOfFloor = this.getFloorRooms(floorId);
    const rooms = result.rooms;
    const bgCanvas = document.createElement('canvas');
    const overlayCanvas = document.createElement('canvas');
    const overlayScale = 2;
    const canvasSize = Math.ceil(900 * lengthOf1Px);
    const overlaySize = canvasSize * overlayScale;
    bgCanvas.width = bgCanvas.height = canvasSize;
    overlayCanvas.width = overlayCanvas.height = overlaySize;

    let globalMax = 0;
    rooms.forEach(room => {
      if (room.outmax > globalMax) {
        globalMax = room.outmax;
      }
    });

    const bgCtx = bgCanvas.getContext('2d');
    const overlayCtx = overlayCanvas.getContext('2d');
    var bgImgData = bgCtx.getImageData(0, 0, canvasSize, canvasSize);
    var bgPixData = bgImgData.data;

    rooms.forEach(ajaxRoom => {
      this.drawRoomLighting(ajaxRoom, globalMax, bgPixData, overlayCtx, canvasSize, overlayScale, lengthOf1Px, allRoomsOfFloor);
    });

    bgCtx.putImageData(bgImgData, 0, 0);

    const resultCanvas = this.mergeLayers(overlaySize, bgCanvas, overlayCanvas);

    return resultCanvas.toDataURL();
  }

  mergeLayers(biggerCanvasSize, bgCanvas, overlayCanvas) {
    const resultCanvas = document.createElement('canvas');
    resultCanvas.width = resultCanvas.height = biggerCanvasSize;
    const resultCtx = resultCanvas.getContext('2d');

    /* resultCtx.filter = "blur(2px)"; */
    resultCtx.drawImage(bgCanvas, 0, 0, biggerCanvasSize, biggerCanvasSize);
    resultCtx.filter = "none";
    resultCtx.drawImage(overlayCanvas, 0, 0, biggerCanvasSize, biggerCanvasSize);
    return resultCanvas;
  }

  drawRoomLighting(ajaxRoom, globalMax, bgPixData, overlayCtx, canvasSize, overlayScale, lengthOf1Px, allRoomsOfFloor) {
    this.drawHeatmap(ajaxRoom, bgPixData, globalMax, canvasSize);
    this.drawOverlay(ajaxRoom, overlayCtx, globalMax, overlayScale, lengthOf1Px, allRoomsOfFloor);
  }

  drawHeatmap(ajaxRoom, bgPixData, outMax, canvasSize) {
    for (let i = 0; i < ajaxRoom.output_values.length; i += 3) {
      const x = ajaxRoom.output_values[i];
      const y = ajaxRoom.output_values[i + 1];
      const luxVal = ajaxRoom.output_values[i + 2];
      const color = this.getColorForLux(luxVal);
      const off = (y * canvasSize + x) * 4;

      bgPixData[off] = color[0];
      bgPixData[off + 1] = color[1];
      bgPixData[off + 2] = color[2];
      bgPixData[off + 3] = 255;
    }
  }

  drawOverlay(ajaxRoom, overlayCtx, outMax, overlayScale, lengthOf1Px, allRoomsOfFloor) {
    /* const xMin = ajaxRoom.x1;
    const roomWidth = ajaxRoom.x2 - ajaxRoom.x1;
    const roomHeight = ajaxRoom.y2 - ajaxRoom.y1;
    const yMin = ajaxRoom.y1; */
    /* const room = this.getRoomById(ajaxRoom.id); */
    const attachedRooms = {};
    const alreadyDrewTextAt = [];


    Object.entries(ajaxRoom.contour).forEach(entry => {
      const array = entry[1];
      if (Array.isArray(array) && array.length >= 2 && array.length % 2 === 0) {
        const len = array.length;
        const testPcnts = [];
        for (let i = 0; i <= 1; i += 0.1) {
          testPcnts.push(i);
        }
        const testPts = [];
        testPcnts.forEach(pcnt => {
          let idx = (len - 1) * pcnt;
          idx = Math.round(idx);
          if (idx % 2 === 1) { idx--; }
          testPts.push({ x: array[idx] / lengthOf1Px, y: array[idx + 1] / lengthOf1Px })
        })
        testPts.forEach(pt => {
          const validRoom = whichRoomIsPointInFromRooms(pt, allRoomsOfFloor);
          if (validRoom) {
            attachedRooms[validRoom.id] = validRoom;
          }
        });
      }
    });

    console.log(attachedRooms);
    const validRooms = Object.values(attachedRooms);

    const contourArrs = Object.entries(ajaxRoom.contour).map(entry => ({ level: entry[0], array: entry[1] }));
    contourArrs.sort((a, b) => b.level - a.level);
    let biggestContourWithEntries = -1
    for (let i = 0; i < contourArrs.length; i++) {
      const obj = contourArrs[i];
      if (obj.array.length) {
        biggestContourWithEntries = obj.level;
        break;
      }
    }

    overlayCtx.fillStyle = `rgba(0, 0, 0, 1)`;
    Object.entries(ajaxRoom.contour).forEach(entry => {
      const level = entry[0];
      const arr = entry[1];
      const datl = arr.length - 3;
      const strokeStyle = "hsl(0,0%," + (1 - level / outMax) * 33 + "%)";
      /* const strokeStyle = "black"; */
      overlayCtx.strokeStyle = strokeStyle;
      const canDrawNearWall = level == biggestContourWithEntries;

      let couldDrawText = false;

      // 1. try to draw ISOTEXT
      try {
        // find a point on the contour line that can be used to draw near to
        for (var idx = 4; idx < datl; idx += 16) {
          const contourPoint = { x: arr[idx], y: arr[idx + 1] };

          const couldDraw = this.tryDrawTextAtAngles(arr, idx, validRooms, contourPoint, alreadyDrewTextAt, overlayCtx, overlayScale, level, strokeStyle, canDrawNearWall, lengthOf1Px);
          if (couldDraw) { couldDrawText = true; break; }
        }
      }
      catch (err) { console.error(err); }

      if (!couldDrawText) {
        /* overlayCtx.strokeStyle = 'red'; */
        return;
      }


      // 2. draw ISOLINE if ISOTEXT succeeded
      for (let i = 0; i < datl; i += 4) {
        overlayCtx.beginPath();
        this.drawLine(overlayCtx, arr[i], arr[i + 1], arr[i + 2], arr[i + 3], overlayScale);
        overlayCtx.stroke();
      }
    });
  }

  wallsOfRooms(rooms) {
    return rooms.map(room => wallsOfRoom(room)).reduce((p, c) => p.concat(c), []);
  }

  tryDrawTextAtAngles(arr, idx, validRooms, point, alreadyDrewTextAt, overlayCtx, overlayScale, text, strokeStyle, canDrawNearWall, lengthOf1Px) {
    const radAngle = Math.atan2((arr[idx + 1] - arr[idx + 3]), (arr[idx] - arr[idx + 2]));
    const radAngle2 = radAngle + Math.PI;
    const downScaledPt = { x: point.x / lengthOf1Px, y: point.y / lengthOf1Px };

    const alreadyDrewTextHere = !uMath.farFromOthersInArray(point, alreadyDrewTextAt, text.length * 7);
    if (alreadyDrewTextHere) { return false; }
    if (!canDrawNearWall) {
      const pointIsCloseToAWall = this.wallsOfRooms(validRooms).some(wall => uMath.pointSegmentDistance_S(downScaledPt, wall) < 10);
      if (pointIsCloseToAWall) { return false; }
    }

    let couldDraw = false;

    [radAngle, radAngle2].forEach(currRadAngle => {
      if (couldDraw) { return; }
      const currDegAngle = radToDeg(currRadAngle);
      const textWidth = text.length * 8 / lengthOf1Px;
      const textHeight = 14 / lengthOf1Px;
      const roomContainsRect1 = uMath.anyRoomContainsRectBot(validRooms, downScaledPt, textWidth, textHeight, currDegAngle);
      if (roomContainsRect1.result) {
        alreadyDrewTextAt.push(point);
        this.drawText(overlayCtx, point, currRadAngle, overlayScale, text, strokeStyle);
        couldDraw = true;

        return;
      }

      const distantPt = uMath.pointAtAngleDistance(downScaledPt, currDegAngle, 5);
      const roomContainsRect2 = uMath.anyRoomContainsRectBot(validRooms, distantPt, textWidth, textHeight, currDegAngle)

      if (roomContainsRect2.result) {
        const upScaledDistantPt = { x: distantPt.x * lengthOf1Px, y: distantPt.y * lengthOf1Px };
        alreadyDrewTextAt.push(upScaledDistantPt);
        this.drawText(overlayCtx, upScaledDistantPt, currRadAngle, overlayScale, text, strokeStyle);
        couldDraw = true;

        return;
      }
    });

    return couldDraw;
  }

  fetchCanvasB64(floorId) {
    return new Promise((res, rej) => {
      $.ajax({
        headers: getAuthHeaderSync(),
        url: ROOT_URI + "/lighting/calculation",
        method: "POST",
        data: { floor_id: floorId },
        dataType: 'JSON',
        success: (result) => {
          try {
            if (!result.rooms.length || result.rooms.every(room => room.output_values.length === 0)) {
              return rej();
            }
            return res(this.serverResultToDataURL(result, floorId));
          }
          catch (err) {
            console.error(err);
            return rej();
          }
        },
        error: (err) => {
          return rej();
        }
      });
    });
  }

  stopAjax() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
    if (this.currentAjax && typeof this.currentAjax === "object") {
      this.currentAjax.abort();
      this.currentAjax = null;
    }
  }

  stopDraw() {
    if (this.currentRequestedFrame) {
      cancelAnimationFrame(this.currentRequestedFrame);
      this.currentRequestedFrame = null;
    }
  }

  stopTimeout() {
    if (this.willRequestTimeout) {
      clearTimeout(this.willRequestTimeout);
      this.willRequestTimeout = null;
    }
  }

  revokeLastUrl() {
    if (this.prevObjectUrl) {
      URL.revokeObjectURL(this.prevObjectUrl);
    }
  }

  startLightCalcMode() {
    setMode.basic();

    this.stopCalculation();
    this.inLightCalcMode = true;
    this.lightCalcLoading = true;

    toolbarSwitchSet('lighting-display', "loading");

    const st = +new Date();
    return this.startAjax(PlannerGlobals.plannerFloorId)
    .then((a) => {
      this.lightCalcLoading = false;
      toolbarSwitchSet('lighting-display', "on");
    })
    .catch((err) => {
      this.stopLightCalcMode();
      throw err;
    })
    .finally(() => {
      const et = +new Date();
      console.log(et - st + "ms")
      stopLoading();
    });
  }

  stopLightCalcMode() {
    if (this.inLightCalcMode) {
      this.stopCalculation();
    }
    toolbarSwitchSet('lighting-display', "off");
  }

  stopBackgroundTasks() {
    this.stopAjax();
    this.stopDraw();
    this.stopTimeout();
  }

  stopCalculation() {
    this.stopBackgroundTasks();
    this.setInitialVars();
    this.revokeLastUrl();
    PlannerGlobals.container.select('#lightingCalc').remove();
  }
}

